var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandidateLeadsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57143 6.15976C4.57143 3.20499 7.00686 0.800781 10 0.800781C12.9931 0.800781 15.4286 3.20499 15.4286 6.15976C15.4286 9.11452 12.9931 11.5187 10 11.5187C7.00686 11.5187 4.57143 9.11452 4.57143 6.15976ZM13.4286 13.211H6.57143C2.94857 13.211 0 16.1218 0 19.6982C0.000605414 20.5209 0.331921 21.3097 0.92119 21.8914C1.51046 22.4731 2.30951 22.8002 3.14286 22.8008H16.8571C17.6905 22.8002 18.4895 22.4731 19.0788 21.8914C19.6681 21.3097 19.9994 20.5209 20 19.6982C20 16.1218 17.0514 13.211 13.4286 13.211Z",
    fill: "#267072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateLeadsActive);
export default __webpack_public_path__ + "static/media/candidateLeads_active.459deb2527d8026cd88474a452f64317.svg";
export { ForwardRef as ReactComponent };